/**
  // 使用方法
  import genOpenAmapMixin from '../../js/gen-openamap-mixin';
  const openAmapMixin = genOpenAmapMixin();
  mixins: [openAmapMixin],
 
  // 端外，呼进端内首页 or 呼进端内打车页
  this.openAmapClickHandle( 'index' || 'taxi', autoopen, token ); 
  
  // 端内，跳打车
  this.amapJumpTaxiPage();

  // 微信点击浏览器打开，链接和成功的 token 拼接处理
 */

import {
  os,
  util,
  webviewInfo
} from '@ali/amap-lib';
import callNative from '@ali/act-util/callNative'
import browserApi from './amap-browser';
import jumpHandler from './jumpHandler';
import service from './service.js'
import CONFIG_URL from '../../config/config.url';
import callupConfig from '../../config/default.call.rules.config'



function ready(callback) {
  // 如果jsbridge已经注入则直接调用
  if (window.AlipayJSBridge) {
    callback && callback();
  } else {
    // 如果没有注入则监听注入的事件
    document.addEventListener('AlipayJSBridgeReady', callback, false);
  }
}

const openAmapMixin = () => {
  return {
    data() {
      return {
        openAmapPageUrl: '',
        openAmapTaxiUrl: '',
        isCurentInWeixin: false, // 当前是否在微信环境下
        taxiSchema: 'amapuri://drive/takeTaxi?sourceApplication=activity_2020_taxiGetNew&clearStack=1', // 打车schema，拼接 &clearStack=1 做清栈操作
        sourceApplicationName: '',
      };
    },
    mounted() {
      // 根据拼接参数不同更新打车链接
      this.changeTaxiSchema();
      this.isCurentInWeixin = webviewInfo.isInWeixin();
      // 端外 && 非微信，处理呼起链接
      if (!webviewInfo.isInAmap()) {
        if(window.location.href.indexOf('pricecomparison.html') !== -1){
          this.renderOpenAmapUrl(2);
        }else{
          this.renderOpenAmapUrl();
        }
        
      }
    },
    methods: {
      // 根据 gd_from 拼接打车 schema
      changeTaxiSchema() {
        let urlParam = util.getUrlParam();
        const sourceId = urlParam.gd_from;
        const driver_sharecode = urlParam.sharecode || urlParam.driver_sharecode || '';
        const share_type = urlParam.sharetype || urlParam.share_type || '';
        this.sourceApplicationName = driver_sharecode && share_type
          ? `duanwailinqguan_invite_${sourceId}` 
          : `duanwailinqguan_${sourceId}`;
        this.taxiSchema = `amapuri://drive/takeTaxi?sourceApplication=activity_2020_taxiGetNew&clearStack=1`
        console.log('taxiSchema: ', this.sourceApplicationName, this.taxiSchema);
      },
      /**
       * 渲染呼起链接
       */
      renderOpenAmapUrl(num = 1) {
        // 端内首页呼起链接
        let renderUrl;
        if(num === 2){
          renderUrl = `${CONFIG_URL.pricecomparison}${window.location.search}`;
        }else{
          renderUrl = `${CONFIG_URL.index}${window.location.search}`;
        }
        
        this.openAmapPageUrl = this.getOpenAmapSchema(renderUrl, false);
        // 端内打车呼起链接
        this.openAmapTaxiUrl = this.getOpenAmapSchema(this.taxiSchema);
      },

      /**
       * 生成呼起链接schema
       * @param sourceUrl {string} 需要在amap里打开的url\schema
       * @param noCommon {Boolean} 是否针对安卓ios使用不同协议iosamap、androidamap，默认false使用通用协议amapuri
       * @returns {string}
       */
      getOpenAmapSchema(sourceUrl, isHideTitle = false) {
        // 检查是否schema
        const isSchema = /^(?:(?:ios|android)amap|amapuri):\/\//i.test(sourceUrl);
        if (isSchema) {
          return /^(?:(?:ios|android)amap|amapuri)(:\/\/.*)$/i.exec(sourceUrl)[0];
        }
        const hideTitle = isHideTitle ? 1 : 0;
        return `amapuri://webview/amaponline?url=${encodeURIComponent(sourceUrl)}&hide_title=${hideTitle}&sourceApplication=activity_2020_taxiGetNew&urlType=0&contentType=autonavi`
      },

      /**
       * 端外，点击按钮呼起事件
       */
      openAmapClickHandle(type = 'index', autoopen = false, token = '') {
        if (service.browserEnvironment() === 'Alipay' && !os.ios) {
          const _this =this
          ready(function(){
              AlipayJSBridge.call('isInstalledApp', {
                packagename: 'com.autonavi.minimap'
              }, function (result) {
                console.log(result)
                // alert(JSON.stringify(result));
                if(result.installed){
                   console.log(type,"----type")
                  if (type === 'index') {
                    // 非微信，呼起首页
                    console.log('非微信-首页--安卓支付宝', _this.openAmapPageUrl);
                    // browserApi.openAmap(_this.openAmapPageUrl);
                    callNative(_this.openAmapPageUrl, callupConfig, {
                      success(data){
                        console.log('呼起成功', data)
                      },
                      fail(data){
                        console.log('呼起失败', data)
                      },
                      process(data){
                        const {rule} = data
                        if(rule !== 'auto') {
                          console.log('todo log')
                        }
                      }
                    })
                    .catch(()=> false)
                  } else if (type === 'taxi') {
                    // 非微信，呼起打车页
                    console.log('非微信-打车--安卓支付宝', _this.openAmapTaxiUrl);
                    // browserApi.openAmap(_this.openAmapTaxiUrl);
                    callNative(_this.openAmapTaxiUrl, callupConfig, {
                      success(data){
                        console.log('呼起成功', data)
                      },
                      fail(data){
                        console.log('呼起失败', data)
                      },
                      process(data){
                        const {rule} = data
                        if(rule !== 'auto') {
                          console.log('todo log')
                        }
                      }
                    })
                    .catch(()=> false)
                  }
                }else{
                  const source = util.getUrlParam('gd_from') || '';
                  window.location.href = `${CONFIG_URL.download}?gd_from=${source}`;
                  // window.location.href='http://30.96.216.126:8010/download.html'
                }
              });
          });

        } else {
          if (this.isCurentInWeixin) {

            // 微信，替换带token的链接 & 打开引导
            const tokenStr = util.getUrlParam('token');
            if (!tokenStr && token) {
              if (history.replaceState) {
                history.replaceState({}, '', `${location.href}&token=${token}`);
              } else {
                location.replace(`${location.href}&token=${token}`)
              }
            }
            // const callUrl = this.getOpenAmapSchema(location.href)
            callNative(this.openAmapTaxiUrl, callupConfig, {
              success(data){
                console.log('呼起成功', data)
              },
              fail(data){
                console.log('呼起失败', data)
              },
              process(data){
                const {rule} = data
                if(rule !== 'auto') {
                  console.log('todo log')
                }
              }
            }).catch(() => false)
            console.log('微信', location.href);
          } else {
            if (type === 'index') {
              // 非微信，呼起首页
              console.log('非微信-首页', this.openAmapPageUrl);
              // browserApi.openAmap(this.openAmapPageUrl);
              callNative(this.openAmapPageUrl, callupConfig, {
                success(data){
                  console.log('呼起成功', data)
                },
                fail(data){
                  console.log('呼起失败', data)
                },
                process(data){
                  const {rule} = data
                  if(rule !== 'auto') {
                    console.log('todo log')
                  }
                }
              }).catch(() => false)
            } else if (type === 'taxi') {
              // 非微信，呼起打车页
              console.log('非微信-打车--非安卓支付宝', this.openAmapTaxiUrl);
              // browserApi.openAmap(this.openAmapTaxiUrl);
              callNative(this.openAmapTaxiUrl, callupConfig, {
                success(data){
                  console.log('呼起成功', data)
                },
                fail(data){
                  console.log('呼起失败', data)
                },
                process(data){
                  const {rule} = data
                  if(rule !== 'auto') {
                    console.log('todo log')
                  }
                }
              }).catch(() => false)
            }
            if (os.ios && service.browserEnvironment() === 'Alipay') {
              setTimeout(()=>{
                const source = util.getUrlParam('gd_from') || '';
                window.location.href = `${CONFIG_URL.download}?gd_from=${source}`;
               },3000)
            }
            
              // console.log('呼起失败');
  
            // 1秒后呼起失败跳打车专属下载页
            // if (autoopen) {
                 
                
            // }
          }
        }



      },

      /***
       * 
       * 直接呼起下载页面
       */
      getDowmload() {
        const source = util.getUrlParam('gd_from') || '';
        return `${CONFIG_URL.download}?gd_from=${source}`;
      },

      /**
       * 端内，点击跳打车页面事件
       */
      amapJumpTaxiPage() {
        jumpHandler(this.taxiSchema, {
          needSchema: true,
          delay: 0,
          hideTitleBar: true,
        });
      },

      // method end
    }
  };
};

export default openAmapMixin;
